import React from 'react';
import { observer } from 'mobx-react';
import {
    Security as SecurityIcon,
} from '@material-ui/icons';

import Banner from '../../commons/banner/Banner';
import usePhoneVerificationBanner from './usePhoneVerificationBanner';

function PhoneVerificationBanner() {
    const { showBanner, handleVerifyNow, handleDismiss } = usePhoneVerificationBanner();

    if (!showBanner) {
        return null;
    }

    return (
        <Banner
            icon={<SecurityIcon />}
            title="Important Notice"
            actionLabel="Verify"
            onAction={handleVerifyNow}
            onDismiss={handleDismiss}
            dismissAriaLabel="Dismiss phone verification banner"
        >
            <strong>Enhance your security:</strong>
            {' Verify your phone number to enable SMS authentication.'}
        </Banner>
    );
}

const ObservedPhoneVerificationBanner = observer(PhoneVerificationBanner);

export default ObservedPhoneVerificationBanner;
